<div class="app-type-container">
    <div #binding>
        <app-binding-home></app-binding-home>
    </div>
    <div #testing>
        <app-testing-home></app-testing-home>
    </div>
    <div #stocking>
        <app-stocking-home></app-stocking-home>
    </div>
</div>